<template>
  <div
    v-accessibility-focus="choose"
    class="o-radiobutton"
  >
    <i
      class="o-radiobutton__icon o-icon"
      :class="[isChosen ? 'o-icon--radiobox-marked' : 'o-icon--radiobox-blank']"
    ></i>
    <div class="o-radiobutton__label">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    model: {
      prop: 'modelValue',
    },
    props: {
      required: {
        type: Boolean,
        default: false,
      },
      modelValue: {
        type: [Boolean, String],
        default: false,
      },
      value: {
        type: [Boolean, String],
        default: null,
      },
    },
    computed: {
      isChosen() {
        if (this.value !== undefined && this.value !== null) {
          return this.modelValue === this.value;
        }
        return this.modelValue;
      },
    },
    methods: {
      choose() {
        if (this.value !== undefined && this.value !== null) {
          return this.$emit('input', this.value);
        }
        this.$emit('input', true);
      },
    },
  };
</script>
